<template>
    <div
        :class="[
            icon ? 'svg-icon' : 'svg-image',
            'svg-' + glyph,
            styling
        ]"
    >
        <svg
            preserveAspectRatio="xMinYMin"
            role="img"
            :class="[
                !icon ? 'svg-' + glyph : '',
                styling
            ]"

        >
            <use
                :xlink:href="src"
            >
            </use>
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'icon',
        props: {
            icon: {
                type: Boolean,
                required: true
            },
            glyph: {
                type: String,
                default: 'pyramid',
                required: true
            },
            styling: {
                type: String,
                default: '',
                required: false
            }
        },
        data() {
            return {
                src: [`/static/svg/sprite.symbol.svg?${new Date().getTime()}#${this.glyph}`]
            }
        },
    };
</script>

<style scoped>
</style>
